<div class="city-chips-container">
  <!-- Cidades Selecionadas -->
  @if (selectedCitiesSignal().length > 0) {
    <div class="selected-cities-section" [@fadeIn]>
      <div class="section-header">
        <h4 class="section-title">
          <mat-icon class="section-icon">location_on</mat-icon>
          Cidades Selecionadas ({{ selectedCount() }})
        </h4>
        <button 
          mat-button 
          color="warn"
          class="clear-button"
          (click)="clearAll()"
          aria-label="Limpar todas as seleções">
          <mat-icon>clear</mat-icon>
          Limpar todas
        </button>
      </div>
      
      <div class="chips-list selected-chips">
        @for (city of selectedCitiesSignal(); track city.name + city.state) {
          <mat-chip 
            class="city-chip selected-chip"
            [removable]="true"
            (removed)="removeCity(city)"
            [@chipAnimation]
            [attr.aria-label]="'Remover ' + city.name + ', ' + city.state">
            <span class="chip-content">
              <span class="city-name">{{ city.name }}, {{ city.state }}</span>
              @if (city.distance !== undefined) {
                <span class="city-distance">{{ formatDistance(city.distance) }}</span>
              }
            </span>
            <button matChipRemove aria-label="Remover cidade">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        }
      </div>
    </div>
  }

  <!-- Cidades Disponíveis -->
  @if (availableCitiesSignal().length > 0) {
    <div class="available-cities-section" [@fadeIn]>
      <div class="section-header">
        <h4 class="section-title">
          <mat-icon class="section-icon">explore</mat-icon>
          Cidades Próximas ({{ availableCitiesSignal().length }})
        </h4>
        <button 
          mat-button 
          color="primary"
          class="select-all-button"
          (click)="toggleSelectAll()"
          [attr.aria-label]="allSelected() ? 'Desmarcar todas as cidades' : 'Selecionar todas as cidades'">
          <mat-icon>{{ allSelected() ? 'remove_done' : 'done_all' }}</mat-icon>
          {{ allSelected() ? 'Desmarcar todas' : 'Selecionar todas' }}
        </button>
      </div>
      
      <div class="chips-list available-chips">
        @for (city of availableCitiesSignal(); track city.name + city.state) {
          <mat-chip 
            class="city-chip available-chip"
            [class.selected]="isCitySelected(city)"
            (click)="toggleCity(city)"
            [@chipAnimation]
            [attr.aria-label]="'Selecionar ' + city.name + ', ' + city.state"
            [attr.aria-pressed]="isCitySelected(city)">
            <span class="chip-content">
              <span class="city-name">{{ city.name }}, {{ city.state }}</span>
              @if (city.distance !== undefined) {
                <span class="city-distance">{{ formatDistance(city.distance) }}</span>
              }
            </span>
          </mat-chip>
        }
      </div>
    </div>
  }

  <!-- Estado Vazio -->
  @if (availableCitiesSignal().length === 0 && selectedCitiesSignal().length === 0) {
    <div class="empty-state">
      <mat-icon class="empty-icon">location_city</mat-icon>
      <p class="empty-message">Nenhuma cidade disponível</p>
      <p class="empty-hint">Selecione um estado e cidade de referência, e defina um raio para ver cidades próximas.</p>
    </div>
  }
</div>
